let host: any = [];
if (typeof window !== 'undefined') {
	host = window.location.host.split('.');
}
let url = '';
let APP_CLIENT = '';

if (host?.includes('web-stage')) {
	APP_CLIENT = 'web-stage';
} else if (host?.includes('web-test')) {
	APP_CLIENT = 'web-test';
} else {
	APP_CLIENT = 'web';
}

switch (APP_CLIENT) {
	case 'web-stage':
		url = 'https://api-stage.ylspares.yantralive.com/api/v1/';
		break;

	case 'web':
		url = 'https://api-prod.ylspares.yantralive.com/api/v1/';
		break;
	default:
		url = 'https://api-test.ylspares.yantralive.com/api/v1/';
}

const apiConfig = {
	url,
	APP_CLIENT,
};

export default apiConfig;
